import { createSupplier, updateSupplier } from '../../../HttpRequests/suppliers';
import { setSubmitting } from '../State/submitting';
import handleException from '../../../Core/Helpers/handleException';
import { message } from 'antd';
import { getProps } from '../props';

export default () => async (dispatch, getState) => {

  const { onClose, didCreate, didUpdate } = getProps();
  const { form, supplier } = getState().modals.Supplier;

  try {

    dispatch(setSubmitting(true));

    if (supplier) {
      await updateSupplier({ id: supplier.id, data: form });
      message.success('Supplier updated successfully');
      if (didUpdate) didUpdate();
    } else {
      await createSupplier({ data: form });
      message.success('Supplier created successfully');
      if (didCreate) didCreate();
    }

    if (onClose) onClose();

  } catch (error) {
    handleException(error);
  } finally {
    dispatch(setSubmitting(false));
  }
}
